import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Button,
  Upload,
  Skeleton,
  message,
  Flex,
  Row,
} from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  clearDeficiencyCheck,
  getPatients,
} from "../../models/documentDeficiencySlice";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  getPreAuthStepper,
  updateAllDocumentsData,
} from "../../apis/patientService";
import { errorMessage, successMessage } from "../../utils/notificationUtils";
import "../../components/patient/TableCssForDocDeficiency.css";
import Loader from "../../utils/Spinners";
import { Tooltip } from "antd";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
} from "../../models/patientSlice";
import { UploadDocument } from "../../models/EnhancementSlice";
import { IDocumentFields } from "../../interfaces/ICase";
import FilePreviewModal from "../../components/patient/PreAuth-query/FilePreviewModal";
import { setSelectedFile } from "../../models/visitSlice";
import DocumentDeficiencyModal from "../../components/patient/DocumentDeficiencyModal";
import { fetchPreAuthStepper } from "../../models/preAuthSlice";
import DocumentDeficiencyPreviewModal from "./DocumentDeficiencyPreviewModal";
import { getClaimData } from "../../models/claimSlice";
import MultipleFilesPreviewModal from "../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import { getSchemeDisplayName } from "../../utils/schemeDisplay";

const DocumentDeficiencyPerPatient: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { documentDeficiency, auth, enhancement, patients, visit } =
    useSelector((state: RootState) => state);

  const [previewFile, setPreviewFile] = useState({
    url: "",
    stage: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const selectedFile = useSelector(
    (state: RootState) => state?.visit?.uploadDocument?.selectedFile,
  );
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any | null>(null);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null,
  );
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
    Record<string, Array<IDocumentFields>>
  >({});
  const [documentData, setDocumentData] = useState<any | null>(null);
  const [staticTabs, setStaticTabs] = useState<any>([]);

  const location = useLocation();
  const pathParts = location.pathname.split("/");

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewIsPdf, setPreviewIsPdf] = useState(false);
  const [showDeficiencyPanel, setShowDeficiencyPanel] = useState(false);
  const [documentUrls, setDocumentUrls] = useState<any>([]);
  const [documentTypes, setDocumentTypes] = useState<any>([]);
  const [documentName, setDocumentName] = useState<string | null>(null);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [previewDocument, setPreviewDocument] = useState(false);
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [portalSubmission, setPortalSubmission] = useState(false);
  const [claimData, setClaimData] = useState<any>();
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string; stage: any }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
      stage: any;
    }[]
  >([]);
  const [activeKey, setActiveKey] = useState<any>("");

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  // const staticTabs = [
  //   { id: 0, label: "ALL", value: "ALL" },
  //   { id: 1, label: "REGISTRATION", value: "REGISTRATION" },
  //   { id: 2, label: "PRE-AUTHORISATION", value: "PRE-AUTHORISATION" },
  //   { id: 3, label: "ENHANCEMENT", value: "ENHANCEMENT" },
  //   { id: 4, label: "DISCHARGE", value: "DISCHARGE" },
  //   { id: 5, label: "CLAIM", value: "CLAIM" },
  // ];

  const [selectedTab, setSelectedTab] = useState<any>();

  useEffect(() => {
    setSelectedTab(staticTabs?.[0]);
  }, [staticTabs]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocumentId) {
        dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId),
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleTabChange = (tab: (typeof staticTabs)[0]) => {
    setSelectedTab(tab);
  };
  // Locate and extract IDs

  const caseId = parseInt(
    pathParts[pathParts.indexOf("document-deficiency") + 1],
    10,
  );
  const visitId = parseInt(
    pathParts[pathParts.indexOf("document-deficiency") + 2],
    10,
  );
  const schemeMetaDataId = parseInt(
    pathParts[pathParts.indexOf("document-deficiency") + 3],
    10,
  );

  const handleFetchStepper = async () => {
    if (caseId && visitId) {
      const res = await getPreAuthStepper(caseId, visitId);
      const stagesInOrder = res?.visitStages
        ?.sort((a: any, b: any) => a.stageLevelId - b.stageLevelId)
        ?.map((item: any, index: number) => ({
          id: item?.visitStageId,
          label: item?.visitStage?.toUpperCase(),
          value: item?.visitStage?.toUpperCase(),
        }));

      setStaticTabs([{ id: 0, label: "ALL", value: "ALL" }, ...stagesInOrder]);
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl,
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  useEffect(() => {
    if (claimData) {
      setPortalSubmission(claimData?.submitted);
    }
  }, [claimData]);

  useEffect(() => {
    handleFetchStepper();
  }, []);

  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number,
  ) => {
    try {
      setLoading(true);
      // const documentList = await getDocuments(props?.schemeMetaDataId);
      if (caseId && visitId) {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId,
        );
        setDocumentData(AllDocumentList);
        setDocumentTypes(Object.values(AllDocumentList).flat());
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const listOfUploadedDocuments = documentTypes?.flatMap(
  //     (item: any) =>
  //       item?.documentList?.map((doc: any) => ({
  //         key: doc?.id,
  //         id: doc?.id,
  //         documentName: doc?.documentName,
  //         documentType: doc?.documentType,
  //         documentUrl: doc?.documentUrl,
  //         documentLabelType: doc?.documentLabelType,
  //         deficiencyCheckStatus: doc?.deficiencyCheckStatus,
  //       })) || []
  //   );

  //   setDocumentUrls(listOfUploadedDocuments);
  // }, [documentTypes]);

  useEffect(() => {
    const addedIds = new Set();

    const listOfUploadedDocuments = documentTypes?.flatMap(
      (item: any) =>
        item?.documentList
          ?.filter((doc: any) => {
            if (!doc?.id || addedIds.has(doc.id)) {
              return false;
            }
            addedIds.add(doc.id);
            return true;
          })
          ?.map((doc: any) => ({
            key: doc?.id,
            id: doc?.id,
            documentName: doc?.documentName,
            documentType: doc?.documentType,
            documentUrl: doc?.documentUrl,
            documentLabelType: doc?.documentLabelType,
            deficiencyCheckStatus: doc?.deficiencyCheckStatus,
          })) || [],
    );

    setDocumentUrls(listOfUploadedDocuments);
  }, [documentTypes]);

  useEffect(() => {
    if (schemeMetaDataId && caseId && visitId) {
      fetchDocuments(schemeMetaDataId, caseId, visitId);
    }
  }, [schemeMetaDataId, caseId, visitId]);

  // Transform document data from all sections into a flat array
  // const transformDocumentsToTableData = () => {
  //   const allDocuments: any[] = [];
  //   let srNo = 1;

  //   const processSection = (section: any[], sectionName: string) => {
  //     section?.forEach((doc) => {
  //       if (doc.label) {
  //         const documentFromList = doc.documentList?.[0];
  //         allDocuments.push({
  //           srNo: srNo++,
  //           document: doc.label,
  //           documentName: documentFromList?.documentName || "Browse file",
  //           documentLabelType: documentFromList?.documentLabelType,
  //           documentUrl: documentFromList?.documentUrl || null,
  //           documentId: documentFromList?.id || null,
  //           deficiencyStatus: getDeficiencyStatus(
  //             documentFromList?.deficiencyCheckStatus
  //           ),
  //           lastUpdated: documentFromList ? formatDate(new Date()) : "-",
  //           required: doc.required,
  //           documentType: doc.labelId,
  //           section: sectionName,
  //         });

  //       }
  //     });
  //   };

  //   processSection(documentData?.PreAuth, "PreAuth");
  //   processSection(documentData?.Discharge, "Discharge");
  //   processSection(documentData?.Claim, "Claim");

  //   return allDocuments;
  // };

  // const transformDocumentsToTableData = () => {
  //   const allDocuments: any[] = [];
  //   let srNo = 1;

  //   const processSection = (section: any[], sectionName: string) => {
  //     section?.forEach((doc, index) => {
  //       if (doc.label) {
  //         const documentFromList = doc.documentList?.[0];
  //         const docData = {
  //           srNo: srNo++,
  //           document: doc.label,
  //           documentName: documentFromList?.documentName || "Browse file",
  //           documentLabelType: documentFromList?.documentLabelType,
  //           documentUrl: documentFromList?.documentUrl || null,
  //           documentId: documentFromList?.id || null,
  //           deficiencyStatus: getDeficiencyStatus(
  //             documentFromList?.deficiencyCheckStatus
  //           ),
  //           lastUpdated: documentFromList ? formatDate(new Date()) : "-",
  //           required: doc.required,
  //           documentType: doc.labelId,
  //           section: sectionName,
  //         };

  //         if (
  //           selectedTab.value === "ALL" ||
  //           sectionName.toUpperCase() === selectedTab.value
  //         ) {
  //           if(docData && !allDocuments?.some(existing => existing.document === docData.document)) {
  //             allDocuments.push(docData);
  //           }
  //           // allDocuments.push(docData);
  //         }
  //       }
  //     });
  //   };

  //   processSection(documentData?.PreAuth, "PRE-AUTHORISATION");
  //   processSection(documentData?.Discharge, "DISCHARGE");
  //   processSection(documentData?.Claim, "CLAIM");

  //   if (selectedTab.value !== "ALL") {
  //     allDocuments?.forEach((doc, index) => {
  //       doc.srNo = index + 1;
  //     });
  //   }

  //   return allDocuments;
  // };

  const transformDocumentsToTableData = () => {
    const allDocuments: any[] = [];
    let srNo = 1;

    const processSection = (section: any, sectionName: string) => {
      section?.forEach((doc: any) => {
        if (doc.label) {
          if (!doc.documentList?.length) {
            const docData = {
              srNo: srNo++,
              document: doc.label,
              documentName: "Browse file",
              documentLabelType: null,
              documentUrl: null,
              documentId: null,
              deficiencyStatus: "-",
              lastUpdated: "-",
              required: doc.required,
              documentType: doc.labelId,
              section: sectionName,
              isMultiple: doc?.multiple,
            };

            if (
              selectedTab?.value === "ALL" ||
              sectionName.toUpperCase() === selectedTab?.value
            ) {
              allDocuments.push(docData);
            }
          } else {
            doc.documentList?.forEach((documentFromList: any) => {
              const docData = {
                srNo: srNo++,
                document: doc.label,
                documentName: documentFromList?.documentName || "Browse file",
                documentLabelType: documentFromList?.documentLabelType,
                documentUrl: documentFromList?.documentUrl || null,
                documentId: documentFromList?.id || null,
                deficiencyStatus: getDeficiencyStatus(
                  documentFromList?.deficiencyCheckStatus,
                ),
                lastUpdated: documentFromList ? formatDate(new Date()) : "-",
                required: doc.required,
                documentType: doc.labelId,
                section: sectionName,
                isMultiple: doc?.multiple,
              };

              if (
                selectedTab?.value === "ALL" ||
                sectionName.toUpperCase() === selectedTab?.value
              ) {
                if (
                  docData &&
                  !allDocuments?.some(
                    (existing) =>
                      existing.document === docData.document &&
                      existing.documentId === docData.documentId,
                  )
                ) {
                  allDocuments.push(docData);
                }
              }
            });
          }
        }
      });
    };

    if (documentData) {
      for (const [stageName, stageDocuments] of Object.entries(documentData)) {
        processSection(stageDocuments, stageName?.toUpperCase());
      }
    }

    if (selectedTab?.value !== "ALL") {
      allDocuments?.forEach((doc, index) => {
        doc.srNo = index + 1;
      });
    }

    return allDocuments;
  };

  const getDeficiencyStatus = (status: boolean | null) => {
    if (status === null || status === undefined) return "Not Completed";
    return status ? "Pass" : "Fail";
  };

  const formatDate = (date: Date) => {
    return date.toLocaleString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "srNo",
      key: "srNo",
      width: "7%",
      align: "center" as "center",
    },
    {
      title: "Document",
      dataIndex: "document",
      key: "document",
      width: "23%",
      render: (text: string, record: any) => (
        <Tooltip title={text}>
          <span style={{ textTransform: "initial", fontSize: "14px" }}>
            {text.length > 40 ? `${text.slice(0, 40)}...` : text}{" "}
            {record.required && <span style={{ color: "red" }}>*</span>}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "documentName",
      render: (text: string, record: any) =>
        text === "Browse file" ? (
          // <Upload
          //   multiple={record?.isMultiple}
          //   {...(record?.isMultiple ? { fileList: uploadFileList } : {})}
          //   showUploadList={false}
          //   beforeUpload={() => false}
          //   onChange={handleSelectedDocument(
          //     {
          //       value: record.documentType,
          //       labelId: record.documentType,
          //       documentType: record.documentType,
          //     },
          //     record.section,
          //     record?.isMultiple
          //   )}
          //   // beforeUpload={(file) => {
          //   //   // Create a synthetic event object to match the expected structure
          //   //   const syntheticEvent = {
          //   //     file,
          //   //     fileList: [file],
          //   //   };

          //   //   // Call handleSelectedDocument with the current record's document type and section
          //   //   handleSelectedDocument(
          //   //     {
          //   //       value: record.documentType,
          //   //       labelId: record.documentType,
          //   //       documentType: record.documentType,
          //   //     },
          //   //     record.section,
          //   //     record?.isMultiple
          //   //   )(syntheticEvent);

          //   //   // Return false to prevent automatic upload
          //   //   return false;
          //   // }}
          // >
          //   <Button
          //     type="link"
          //     style={{
          //       padding: 0,
          //       height: "auto",
          //       display: "inline-flex",
          //       alignItems: "center",
          //     }}
          //   >
          //     <Tooltip title="Click to browse file">
          //       <span
          //         style={{
          //           textTransform: "initial",
          //           textDecoration: "underline",
          //           color: "#008B8B",
          //         }}
          //       >
          //         {text}
          //       </span>
          //     </Tooltip>
          //   </Button>
          // </Upload>
          <>-</>
        ) : (
          <>
            <Tooltip title={text}>
              <span style={{ textTransform: "initial" }}>
                {text.length > 20 ? `${text.slice(0, 20)}...` : text}
              </span>
            </Tooltip>
            {/* {record?.isMultiple ? (
              <Upload
                multiple={record?.isMultiple}
                {...(record?.isMultiple ? { fileList: uploadFileList } : {})}
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleSelectedDocument(
                  {
                    value: record.documentType,
                    labelId: record.documentType,
                    documentType: record.documentType,
                  },
                  record.section,
                  record?.isMultiple
                )}
              >
                <Button
                  type="link"
                  style={{
                    padding: 0,
                    height: "auto",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title="Click to browse file">
                    <span
                      style={{
                        textTransform: "initial",
                        textDecoration: "underline",
                        color: "#008B8B",
                        marginLeft: "10px",
                      }}
                    >
                      Browse File
                    </span>
                  </Tooltip>
                </Button>
              </Upload>
            ) : (
              <></>
            )} */}
          </>
        ),
    },
    {
      title: "Uploaded Document",
      dataIndex: "documentUrl",
      key: "uploadedDocument",

      width: "14%",
      render: (url: string, record: any) =>
        url ? (
          <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
            <EyeOutlined
              style={{ fontSize: "17px" }}
              // onClick={() => handlePreview(url)}
              onClick={() => {
                setPreviewUrl(record.documentUrl);
                setPreviewIsPdf(
                  record.documentUrl?.toLowerCase().endsWith(".pdf"),
                );
                setShowDeficiencyPanel(true); // or false, based on your logic
                setIsPreviewOpen(true);
                handlePreview(url, record);
                handleOpen(record?.documentLabelType, record?.documentUrl);
              }}
              // onClick={() => handlePreview(url, record)}
            />
            <DownloadOutlined
              style={{ fontSize: "17px" }}
              onClick={() =>
                handleDownloadDocument(record.documentName ?? "Document", url)
              }
            />
            {/* <DeleteOutlined style={{ fontSize: "17px" }} /> */}
          </div>
        ) : null,
    },
    {
      title: "Deficiency Check Status",
      dataIndex: "deficiencyStatus",
      key: "deficiencyStatus",
      render: (status: string, record: any) => {
        const color =
          status === "Pass"
            ? "#008B8B33"
            : status === "Fail"
              ? "#D2691E33"
              : "#008B8B33";
        const textColor =
          status === "Pass"
            ? "#008B8B"
            : status === "Fail"
              ? "rgb(213, 30, 30)"
              : "rgb(0, 84, 157)";
        return (
          <span
            style={{
              color: record?.lastUpdated !== "-" ? "white" : "black",
              background: record?.lastUpdated !== "-" ? textColor : "none",
              borderRadius: "10px",
              padding: "4px 12px",
              textTransform: "initial",
              fontSize: "15px",
            }}
          >
            {status === "Pass"
              ? "Approved"
              : status === "Fail"
                ? "Rejected"
                : status}
          </span>
        );
      },
    },
    {
      title: "Last Updated",
      dataIndex: "lastUpdated",
      key: "lastUpdated",
      render: (text: string) => (
        <Tooltip title={text}>
          <span>{text.length > 20 ? `${text.slice(0, 20)}...` : text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) =>
        record.documentUrl !== null ? (
          <Button
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "10px",
              color: "#222222",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
              padding: "2px 10px",
            }}
            type="primary"
            // onClick={() => handleDocumentClick(record)}
            onClick={() => {
              setPreviewUrl(record.documentUrl);
              setPreviewIsPdf(
                record.documentUrl?.toLowerCase().endsWith(".pdf"),
              );
              setShowDeficiencyPanel(true); // or false, based on your logic
              setIsPreviewOpen(true);
              handlePreview(record?.documentUrl, record);
              handleOpen(record?.documentLabelType, record?.documentUrl);
            }}
          >
            Check Deficiency
          </Button>
        ) : null,
    },
  ];

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (err: any) {
      errorMessage("Please, Try again later");
    }
  };

  const handlePreview = (url: string, record: any) => {
    const findVisitStageId = staticTabs?.find(
      (tab: any) =>
        tab?.value?.toUpperCase() === record?.section?.toUpperCase(),
    );
    setActiveKey(findVisitStageId?.id);
    // window.open(url, "_blank");
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(document.documentUrl);
    setSelectedDocumentId(document.documentId);
    setSelectedDocument(document);
    // setDeficiencyModal(true);
  };

  const handleDocumentClick = (document: any) => {
    // if (selectedDocument?.documentType !== document.documentType) {
    dispatch(clearDeficiencyCheck());
    setSelectedDocument(document);
    handleDeficiencyModalOpen(
      document?.documentUrl,
      document?.documentId,
      document,
    );
    // }
  };

  const closeModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
    dispatch(clearDeficiencyCheck());

    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      dispatch(
        getPatients({
          filters: documentDeficiency?.patientFilters,
          accessToken: auth.accessToken || "",
          healthCareId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        }),
      );
    }
  };

  useEffect(() => {
    if (visitId) {
      dispatch(getBasicDetails({ id: visitId }));
    }
  }, [visitId]);

  const handleSaveData = async (
    uploadDocPayload: Record<string, IDocumentFields[]>,
  ) => {
    if (uploadDocPayload) {
      // setSaveBtnLoading(true);

      const payloadSchema: {
        casePreAuthAttachments: any[];
        caseEnhancementsAttachments: any[];
        caseDischargeAttachments: any[];
        caseClaimAttachments: any[];
        caseBillAuditAttachments: any[];
      } = {
        casePreAuthAttachments: [],
        caseEnhancementsAttachments: [],
        caseDischargeAttachments: [],
        caseClaimAttachments: [],
        caseBillAuditAttachments: [],
      };

      Object.keys(payloadSchema)?.forEach((payloadKey) => {
        const matchKey = Object.keys(uploadDocPayload)?.find((dataKey) =>
          payloadKey.toLowerCase().includes(dataKey),
        );

        if (matchKey) {
          // Use 'as keyof typeof payloadSchema' to assert the type of payloadKey
          payloadSchema[payloadKey as keyof typeof payloadSchema] =
            uploadDocPayload[matchKey];
        }
      });

      if (caseId && visitId && schemeMetaDataId) {
        try {
          const AllDocumentList = await updateAllDocumentsData(
            caseId,
            visitId,
            payloadSchema,
          );
          message.success(`Uploaded documents saved successfully`);
          fetchDocuments(schemeMetaDataId, caseId, visitId);
        } catch (error) {
          message.error(`Something went worng`);
        } finally {
          // setSaveBtnLoading(false);
        }
      }
    }
  };
  const handleSelectedDocument =
    (documentType: any, stage: string, isMultiple: any) => (e: any) => {
      const cleanItem = stage.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType:
            documentType?.labelId ||
            documentType?.documentType ||
            documentType?.value,
          stage: cleanItem,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType:
            documentType?.labelId ||
            documentType?.documentType ||
            documentType?.value,
          isMultiple: isMultiple,
          stage: cleanItem,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        // if (
        //   documentType?.value &&
        //   (documentType?.value?.toUpperCase() === "24" ||
        //     documentType?.value?.toUpperCase() === "1310"?.toUpperCase()) &&
        //   e?.fileList[0]?.type !== "application/pdf"
        // ) {
        //   errorMessage("File Must be PDF only");
        //   return;
        // }

        if (e?.fileList[0] && documentType) {
          dispatch(
            setSelectedFile({
              file: e?.file,
              documentType:
                documentType?.labelId ||
                documentType?.documentType ||
                documentType?.value,
              stage: cleanItem,
            }),
          );

          setPreviewFile({
            stage: cleanItem,
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType:
              documentType?.labelId ||
              documentType?.documentType ||
              documentType?.value,
          });
          setPreviewModalVisible(true);
        }
        //   setSelectedDocumentType(null);
      }
    };

  const updateOrAddDocument = (
    selectedPreAuthStep: string,
    uploadedDocumentUrl: Record<string, Array<IDocumentFields>>,
    documentRes: any,
  ): Record<string, Array<IDocumentFields>> => {
    const cleanItem = selectedPreAuthStep
      .replace(/[^a-zA-Z0-9]/g, "")
      .toLowerCase();

    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CGHS" &&
      cleanItem?.toLowerCase()?.includes("claim")
    ) {
      const updatedDocuments = uploadedDocumentUrl[cleanItem]
        ? [...uploadedDocumentUrl[cleanItem]]
        : [];

      const documentIndex = updatedDocuments.findIndex(
        (doc) => doc?.documentType === documentRes?.documentType,
      );
      if (
        documentIndex !== -1 &&
        documentRes?.documentLabelType?.toUpperCase() !== "BILL ATTACHMENTS" &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "INVESTIGATION REPORTS" &&
        documentRes?.documentLabelType?.toUpperCase() !== "CGHS BILL" &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "CONSULTATION NOTES" &&
        documentRes?.documentLabelType?.toUpperCase() !== "CASE SHEET" &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "CONSUMABLE DOCUMENT" &&
        documentRes?.documentLabelType?.toUpperCase() !== "DRUG CERTIFICATE" &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Implant Bill Attachments"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "IMPLANT INVOICE"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Justification for unspecified package"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "PROCEDURE NOTES"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "Post Procedure X Ray"?.toUpperCase() &&
        documentRes?.documentLabelType?.toUpperCase() !==
          "CLINICAL NOTES"?.toUpperCase()
      ) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else {
        updatedDocuments.push({
          documentType: documentRes?.documentType,
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          documentLabelType: documentRes?.documentLabelType,
          id: documentRes?.id,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        });
      }

      return { ...uploadedDocumentUrl, [cleanItem]: documentRes };
    } else if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "MEDI ASSIST" &&
      (cleanItem?.toLowerCase()?.includes("claim") ||
        cleanItem?.toLowerCase()?.includes("preauth"))
    ) {
      const updatedDocuments = uploadedDocumentUrl[cleanItem]
        ? [...uploadedDocumentUrl[cleanItem]]
        : [];

      const documentIndex = updatedDocuments.findIndex(
        (doc) => doc?.documentType === documentRes?.documentType,
      );
      if (
        documentIndex !== -1 &&
        documentRes?.documentLabelType?.toUpperCase() !== "OTHERS"
      ) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else {
        updatedDocuments.push({
          documentType: documentRes?.documentType,
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          documentLabelType: documentRes?.documentLabelType,
          id: documentRes?.id,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        });
      }

      return { ...uploadedDocumentUrl, [cleanItem]: documentRes };
    } else {
      const updatedDocuments = uploadedDocumentUrl[cleanItem]
        ? [...uploadedDocumentUrl[cleanItem]]
        : [];

      const documentIndex = updatedDocuments.findIndex(
        (doc) => doc?.documentType === documentRes?.documentType,
      );

      if (documentIndex !== -1) {
        updatedDocuments[documentIndex] = {
          ...updatedDocuments[documentIndex],
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
          id: documentRes?.id,
        };
      } else {
        updatedDocuments.push({
          documentType: documentRes?.documentType,
          documentName: documentRes?.documentName,
          documentUrl: documentRes?.documentUrl,
          documentLabelType: documentRes?.documentLabelType,
          id: documentRes?.id,
          deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        });
      }

      // Return the updated array (ensures it's a flat array)
      return { ...uploadedDocumentUrl, [cleanItem]: documentRes };
    }
  };
  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file),
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        if (previewFiles?.[0]?.stage && documentRes) {
          const stage = previewFiles?.[0].stage;
          const updatedDocuments = updateOrAddDocument(
            stage,
            uploadedDocumentUrl,
            documentRes,
          );
          setUploadedDocumentUrl(updatedDocuments);
          // setUploadedDocumentUrlList(updatedDocuments);
          handleSaveData(updatedDocuments);

          // message.success(`Document uploaded successfully`);
        } else {
          message.error(`Document upload failed`);
        }
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
        );
        setSelectedFiles([]);
        setPreviewFiles([]);
        setUploadFileList([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id.toString(),
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
        );
      }

      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          }),
        ).unwrap();

        if (previewFile.stage && documentRes) {
          const stage = previewFile.stage;
          const updatedDocuments = updateOrAddDocument(
            stage,
            uploadedDocumentUrl,
            documentRes,
          );
          setUploadedDocumentUrl(updatedDocuments);
          // setUploadedDocumentUrlList(updatedDocuments);
          handleSaveData(updatedDocuments);

          // message.success(`Document uploaded successfully`);
        } else {
          message.error(`Document upload failed`);
        }

        setPreviewModalVisible(false);
        setSelectedDocument(null);
        //   setSelectedFile(null);
        //   setSelectedDocumentType(null);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };
  // Mock data for patient details - replace with actual data from your state
  const patientDetails: any = {
    fullName: patients?.fetchBasicDetails?.patientResponse?.fullName,
    uhidNo: patients?.fetchBasicDetails?.patientResponse?.uhidNo,
    age: "21",
    visitType: patients?.fetchBasicDetails?.visitInfoResponse?.visitType,
    opNumber: patients?.fetchBasicDetails?.visitInfoResponse?.opNumber || "",
    schemeName: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName,
    creditNoteNo: patients?.fetchBasicDetails?.visitInfoResponse?.creditNumber,
    doa: patients?.fetchBasicDetails?.visitInfoResponse?.doa,
    dod: patients?.fetchBasicDetails?.visitInfoResponse?.dod,
    lastUpdatedAt: patients?.fetchBasicDetails?.patientResponse?.modifiedAt,
    status: patients?.fetchBasicDetails?.visitInfoResponse?.visitStageName,
    alternateName: patients?.fetchBasicDetails?.casesResponse?.alternateName
  };

  return (
    <div
      style={{ padding: "16px", backgroundColor: "#fff" }}
      className="docDeficiency"
    >
      <div style={{ padding: "0 0.5rem" }}>
        <div
          className="patient-details-screen"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            border: "0.4px solid #A6A6A6",
            borderRadius: "10px",
            padding: "2px 0",
            flexWrap: "wrap",
            marginTop: "0.6rem",
            boxShadow: "0px -1px 4px 0px #00000040 inset",
            marginBottom: "1.8rem",
            background: " #008B8B0D",
          }}
        >
          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "17%",
            }}
            onClick={() =>
              navigate(
                `${ROUTES.ALL_VISIT}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
              )
            }
          >
            <Tooltip title={patientDetails.fullName}>
              <p
                style={{
                  marginBottom: "0.6rem",
                  fontSize: "1.2rem",
                  fontWeight: "700",
                  textDecoration: "underline",
                  cursor: "pointer",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {patientDetails?.fullName?.length > 15
                  ? `${patientDetails?.fullName?.slice(0, 20)}...`
                  : patientDetails.fullName}
              </p>
            </Tooltip>
            <p style={{ fontWeight: "600", fontSize: "0.9rem" }}>
              #{patientDetails.uhidNo}
            </p>
          </div>

          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              width: "11%",
              borderRight: "1px solid #A6A6A6",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              Credit Note No.
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.creditNoteNo}
            </p>
          </div>

          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "10%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              Scheme Name
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {getSchemeDisplayName(patientDetails) || patientDetails.schemeName}
            </p>
          </div>

          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "10%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              Visit Type
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.visitType}
            </p>
          </div>

          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "8%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              OP/IP No.
            </p>
            <Tooltip title={patientDetails.opNumber}>
              <p
                style={{
                  fontWeight: "700",
                  fontSize: "0.8rem",
                  minHeight: "1.4rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {patientDetails?.opNumber?.length > 8
                  ? `${patientDetails?.opNumber?.slice(0, 8)}...`
                  : patientDetails.opNumber}
              </p>
            </Tooltip>
          </div>

          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "13%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              DOA
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.doa}
            </p>
          </div>
          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "13%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              DOD
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.dod}
            </p>
          </div>
          {/* <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              borderRight: "1px solid #A6A6A6",
              width: "15%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              Last Updated At
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.lastUpdatedAt}
            </p>
          </div> */}
          <div
            className="items"
            style={{
              padding: "10px 20px 0px 20px",
              //   borderRight: "1px solid #A6A6A6",
              width: "11%",
            }}
          >
            <p
              style={{
                marginBottom: "0.6rem",
                fontSize: "0.8rem",
                fontWeight: "400",
              }}
            >
              Status
            </p>
            <p
              style={{
                fontWeight: "700",
                fontSize: "0.8rem",
                minHeight: "1.4rem",
              }}
            >
              {patientDetails.status}
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
          alignItems: "center",
        }}
      >
        <h2
          style={{
            textTransform: "initial",
            textDecoration: "underline",
          }}
        >
          Document List
        </h2>

        <Button
          style={{
            backgroundColor: "#008B8B",
            color: "white",
            borderRadius: "4px",
            border: "none",
            width: "14%",
          }}
          onClick={() => navigate(ROUTES.DOCUMENT_DEFICIENCY)}
        >
          <ArrowLeftOutlined />
          Back
        </Button>
      </div>

      <Flex
        style={{
          width: "100%",
          // marginBottom: "1em",
          marginTop: 0,
          flexDirection: "column",
        }}
        gap={6}
      >
        <Row style={{}}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Flex gap={0}>
              {staticTabs?.map((tab: any) => (
                <Button
                  key={tab?.id}
                  type={selectedTab?.id === tab?.id ? "primary" : "default"}
                  onClick={() => handleTabChange(tab)}
                  style={
                    selectedTab?.id === tab?.id
                      ? {
                          background: "#008B8B",
                          borderTopLeftRadius: "15px",
                          borderTopRightRadius: "15px",
                          borderBottomLeftRadius: "0px",
                          borderBottomRightRadius: "0px",
                          fontWeight: "700",
                          height: "35px",
                          boxShadow: " 0px -1px 4px 0px #00000040 inset",
                        }
                      : {
                          border: "none",
                          boxShadow: "none",
                          height: "35px",
                          color: "#575757",
                        }
                  }
                >
                  {tab.label}
                </Button>
              ))}
            </Flex>
          </div>
        </Row>
      </Flex>

      <Card
        style={{
          marginBottom: "16px",
          boxShadow: "0px -1px 4px 0px #00000040 inset",
        }}
      >
        {loading ? (
          <Skeleton active paragraph={{ rows: 10 }} />
        ) : (
          <Table
            columns={columns}
            dataSource={transformDocumentsToTableData()}
            pagination={false}
            rowKey="srNo"
            style={{ backgroundColor: "white" }}
            onRow={(record, index: any) => ({
              style: {
                backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#ffffff",
              },
            })}
          />
        )}
      </Card>

      <FilePreviewModal
        isVisible={previewModalVisible}
        onClose={() => {
          setPreviewModalVisible(false);
          //   setSelectedDocumentType(null);
        }}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.lastModified || "no-file"}
        isLoading={enhancement?.isLoading}
      />

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      {/* <PerPatientDeficiencyModal
        schemeMetaDataId={schemeMetaDataId}
        patientDetails={patientDetails}
        caseId={caseId}
        visitId={visitId}
        setDocumentData={setDocumentData}
        loading={loading}
        setLoading={setLoading}
        setSelectedDocument={setSelectedDocument}
        setSelectedDocumentId={setSelectedDocumentId}
        documentList={uploadedDocumentUrl}
        handleDocumentClick={handleDocumentClick}
        key={selectedDocument?.documentUrl}
        closeDeficiencyModal={closeModal}
        deficiencyModal={deficiencyModal}
        documentUrl={selectedDocument?.documentUrl}
        documentName={selectedDocument?.documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={documentDeficiency?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setUploadedDocumentUrl}
        setDeficiencyModal={setDeficiencyModal}
      /> */}

      <DocumentDeficiencyPreviewModal
        open={isPreviewOpen}
        handleCancel={() => setIsPreviewOpen(false)}
        documents={documentUrls}
        setDocumentName={setDocumentName}
        handleDeleteDocument={handleDeleteList}
        handleDownloadDocument={handleDownloadDocument}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={portalSubmission}
        fetchingDeficiencyData={fetchingDeficiencyData}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
        isHospitalBillDischargeSummary={true}
        fetchDocuments={fetchDocuments}
        schemeMetaDataId={schemeMetaDataId}
        caseId={caseId}
        visitId={visitId}
      />
    </div>
  );
};

export default DocumentDeficiencyPerPatient;
